import { useQuery } from "@tanstack/react-query";
import { getSignupRequests } from "../../../api/signupRequestsApi";
import { SignupRequest } from "../../../pages/Admin/UserRequests/signupRequestsMockData";

export const SIGNUP_REQUESTS_QUERY_KEY = ["signup-requests"];

export const useSignupRequests = () => {
  const { data, isLoading } = useQuery<SignupRequest[]>(SIGNUP_REQUESTS_QUERY_KEY, () => getSignupRequests("pending"));
  return { requests: data ?? [], isLoading };
};
